import { Component } from '@angular/core';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
@Component({
  selector: 'app-app-payment-setting',
  templateUrl: './app-payment-setting.component.html',
  styleUrls: ['./app-payment-setting.component.scss'],
  standalone:false
})
export class AppPaymentSettingComponent {
  message!: string;
  imagePath: any;
  imagefileURL!: any | ArrayBuffer;
  imgType!: any | ArrayBuffer;
  setting_data: any
  name: any;
  razorpay_key: any;
  razorpay_secret: any;
  user_id: any;
  event_id: any;

  constructor(
    private service: ServicesService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private location: Location,
    private router: Router
  ) { }

  previewpimage(files: any) {
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.imgType = 'payment_logo';
      this.service.uploadimage(this.imagefileURL, this.imgType).subscribe((data: any) => {
        this.imagePath = data['image_name'];
      });
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.event_id = params['event_id'];
      this.user_id = params['user_id'];
      this.get_PaymentSetting(this.event_id);
    });
  }

  get_PaymentSetting(event_id: any) {
    this.service.getPaymentSetting(event_id).subscribe(
      (data: any) => {
        this.setting_data = data.data;
        this.name = this.setting_data[0].name;
        this.razorpay_key = this.setting_data[0].razorpay_key;
        this.razorpay_secret = this.setting_data[0].razorpay_secret;
        this.imagePath = this.setting_data[0].image;

      });
  }

  Update_setting() {
    const setting = {
      name: this.name,
      razorpay_key: this.razorpay_key,
      razorpay_secret: this.razorpay_secret,
      image: this.imagePath
    }

    this.service.app_editPaymentSetting(setting, this.event_id, this.user_id).subscribe(
      (data: any) => {
        this.toastr.success("Setting Updated Succesfully");
      }
    )
  }
}
